var destinationsCountryTabs = vueIfExists({
	el: '#destinations-country-tabs',
	data: {
		activeTab: 'cities',
		loaded: false
	},
	mounted: function() {
		this.loaded = true;
	}
});